import React, { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { Box, Typography, Button } from "@mui/material";
import { loginRequest } from "../auth/authConfig";
import msalInstance from "../auth/msalInstance";
import { useAlert } from "../hook/useAlert";

const LandingPage = () => {
  const { instance, inProgress, accounts } = useMsal();
  const { onError } = useAlert();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((error) => {
      onError(error);
    });
  };

  useEffect(() => {
    if (isAuthenticated && accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
      sessionStorage.setItem("userName", accounts[0].username);
      navigate("/app");
    }
  }, [isAuthenticated, accounts, navigate]);

  if (inProgress === InteractionStatus.Startup || inProgress === InteractionStatus.HandleRedirect) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: "0",
        backgroundColor: "#f0f0f0",
        height: "100vh",
        width: "100%",
      }}
      className="animate__animated animate__fadeIn animate__delay-05s"
    >
      <Typography variant="h2" sx={{ mb: 10 }}>
        Prospect Configuration Service
      </Typography>
      <Box
        component="img"
        src="/landing-page.png"
        alt="Logo"
        sx={{
          width: "auto",
          maxWidth: "50%",
          height: "auto",
          mb: 10,
        }}
      />
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#ff0000",
          color: "white",
          "&:hover": {
            backgroundColor: "#d10000",
          },
          py: 1,
          px: 3,
          textTransform: "none",
          borderRadius: 1,
        }}
        onClick={handleLogin}
      >
        Sign In with SSO
      </Button>
    </Box>
  );
};

export default LandingPage;
